
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "Error 404: El usuario intentó acceder a una ruta inexistente:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-bike-500 mb-4">404</h1>
        <p className="text-xl text-gray-700 mb-6">¡Ups! No pudimos encontrar la página que estás buscando.</p>
        <p className="text-gray-500 mb-8">
          La página solicitada no se pudo encontrar. Es posible que haya sido movida o que no exista.
        </p>
        <Link to="/">
          <Button className="w-full md:w-auto">
            Volver al Panel Principal
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
